import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { styles } from './tender-processing-title-styles';

interface TenderProcessingTitleProps {
  title: string;
}

const TenderProcessingTitle: React.FC<TenderProcessingTitleProps> = (
  props: TenderProcessingTitleProps,
): JSX.Element => {
  const classes = styles();
  const { title } = props;
  //tender processing title
  return (
    <Grid
      item
      container
      justifyContent='flex-start'
      direction='column'
      className={`${classes.titleContainer} fullWidth`}
    >
      <Typography className={classes.titleHeader} data-testid='tender-processing-title-text'>
        {title}
      </Typography>
      <Grid item>
        <Typography className={classes.titleBar} />
      </Grid>
    </Grid>
  );
};

export default TenderProcessingTitle;
